import React from 'react'
import PropTypes from 'prop-types'
import { Title } from '../title/title.jsx'

export const FundLiteratureFilter = ({
  showClassOption,
  filters,
  selectedFilter,
  setSelectedFilter,
  inputValue,
  setInputValue,
  activeClass,
  setActiveClass,
  classOptions,
}) => {
  const onFilterClick = (i) => {
    let result = [...selectedFilter]
    if (selectedFilter?.includes(i)) {
      result = selectedFilter?.filter((f) => f !== i)
    } else {
      result.push(i)
    }
    setSelectedFilter(result)
  }

  return (
    <div className="u-marginTop3gu u-sm-marginTop15gu u-marginBottom5gu">
      {/* search */}
      <div
        className={
          'u-flex u-flexAlignItemsCenter u-flexAuto u-md-size1of2 u-lg-size1of2 u-bgColorWhite u-sm-paddingLeft0 u-marginVert5gu'
        }
      >
        <div className="u-posRelative u-flexAuto u-paddingBottom2gu">
          <span
            className={
              'Icon--material input-search-icon u-posAbsolute u-textSizeMsrp2 u-textColorBrand fund-literature-search-filter'
            }
            aria-hidden="true"
          >
            &#xE8B6;
          </span>
          <input
            type="text"
            placeholder="Find Literature by Fund"
            className={
              'Input Input--withIcon Icon--before MutualFunds-searchField u-borderColorNeutralLight u-borderBottom u-borderTop0 u-borderLeft0 u-borderRight0'
            }
            value={inputValue}
            onChange={(e) => setInputValue(e.currentTarget.value)}
          />
          {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions -- CTINEXT-4722 */}
          <div
            id={'clearSearch'}
            className="u-posAbsolute u-padding2gu"
            style={{ cursor: 'pointer', top: '0', right: 0 }}
            onClick={() => setInputValue('')}
          >
            <span
              id="cti-navigation-search-clear"
              className={'Icon--material input-close-icon'}
              aria-hidden="true"
            >
              &#xE5CD;
            </span>
          </div>
        </div>
      </div>

      {/* title */}
      <div className="u-marginTop5gu">
        <Title text="Filter by:" mode="medium-large" />
      </div>

      {/* filter - chips */}
      <div className="u-marginTop5gu">
        <div className="Chip-group">
          {filters?.map((i) => (
            <button
              key={i}
              className={`Chip Chip--interactive 
                ${selectedFilter?.includes(i) ? 'Chip--color selected' : ''} 
                u-marginRight2gu u-textCapitalize`}
              onClick={() => onFilterClick(i)}
              tabIndex={0}
              aria-pressed={selectedFilter?.includes(i) ? 'true' : 'false'}
            >
              {i}
            </button>
          ))}
        </div>
        <div className="u-paddingHoriz2gu u-paddingTop2gu u-textRight">
          {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions -- CTINEXT-4722 */}
          <span
            className={`Link HeaderLinks-link ${
              selectedFilter.length === 0 ? 'u-disabled' : ''
            }`}
            style={selectedFilter.length === 0 ? { cursor: 'not-allowed' } : {}}
            onClick={() => setSelectedFilter([])}
          >
            Clear all filters
          </span>
        </div>
      </div>

      {/* class dropdown filter*/}
      {showClassOption && (
        <div className="u-lg-flex u-lg-flexAlignItemsCenter u-sm-marginBottom5gu">
          <label
            className="Form-label u-marginBottom0"
            htmlFor="class_dropdown"
          >
            Class
          </label>
          <div className="Dropdown u-sm-marginLeft0 u-md-marginLeft0 u-marginLeft2gu">
            <select
              id="class_dropdown"
              value={activeClass}
              className="Dropdown-menu"
              onChange={(e) => setActiveClass(e.currentTarget.value)}
            >
              {classOptions?.map((i) => {
                return (
                  <option key={i.key} value={i.key}>
                    {i.label}
                  </option>
                )
              })}
            </select>
          </div>
        </div>
      )}
    </div>
  )
}

FundLiteratureFilter.propTypes = {
  showClassOption: PropTypes.bool,
  filters: PropTypes.arrayOf(PropTypes.string),
  selectedFilter: PropTypes.arrayOf(PropTypes.string),
  setSelectedFilter: PropTypes.func.isRequired,
  inputValue: PropTypes.string,
  setInputValue: PropTypes.func.isRequired,
  activeClass: PropTypes.string,
  setActiveClass: PropTypes.func.isRequired,
  classOptions: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
}
